import axios from "../../axios";

const getChildPartners = async function (accessToken) {
    try {
        const response = await axios.get('/deduction-fees/getChildPartners', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getChildPartners; 
